import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicRateCardNumberActive({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 45 29"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M0 12.68v-3.2h8.55v-8.4h3.35v8.4h8.55v3.2H11.9v8.37H8.55v-8.37H0zM30.08 0h3.02L20.13 28.31H17.1L30.08 0zm-.33 15.24H45v3.63H29.75v-3.63z"
        fill="#E9F7EE"
        opacity={0.6}
      />
    </svg>
  );
}

SvgPicRateCardNumberActive.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicRateCardNumberActive.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicRateCardNumberActive svgRef={ref} {...props} />
));
export default ForwardRef;
